module.exports = __webpack_public_path__ + "static/img/zxr.66eabcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/zxr.png
// module id = REwk
// module chunks = 0